module.exports = __webpack_public_path__ + "static/media/udeSayu.b1087c51.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/locomo/udeSayu.png
// module id = 1710
// module chunks = 1